declare global {
  interface Window {
    Sentry: any;
    simplicityData: any;
    zE: any;
    embeddedservice_bootstrap: any; // salesforce widget bootstrapper
  }
}

export type { Analytics } from "./analytics";
export type {
  BaseDataQuery,
  BaseDataResponseBody,
  ExtendedBaseDataResponseBody,
  ShellDataRequestBody,
  ShellDataResponseBody,
  ShellSecondaryDataRequestQuery,
  ShellSecondaryDataResponseBody,
  BusinessAppData,
  GroupTraitsRequestQuery,
  GroupTraitsResponseBody,
} from "./data";
export type { Styles, MakeStyles } from "./styles";

export enum EmployeePrivilegesProfiles {
  OVERVIEWPRIVILEGE = "OverviewDomainsImpersonation",
  EDITPRIVILEGE = "BusinessAppEditImpersonation",
  ELEVATEDPRIVILEGE = "BusinessAppElevatedImpersonation",
}

export type EmployeePrivileges =
  | EmployeePrivilegesProfiles.OVERVIEWPRIVILEGE
  | EmployeePrivilegesProfiles.EDITPRIVILEGE
  | EmployeePrivilegesProfiles.ELEVATEDPRIVILEGE;

export interface SentryConfig {
  dsn?: string;
  release: string;
}

export interface ShellConnect {
  history: any;
  navigate: (path: string) => void;
  initializeSentry: (config: SentryConfig) => void;
  changeBusinessUnit: (businessUnitId: string) => void;
  navigationCustomEvent: {
    subscribe: (basename: string, callback: (path: string) => void) => void;
    emit: (href: string) => void;
  };
}

export interface ShellProps {
  hasAppError: boolean;
  showSubMenu?: boolean;
  setShowSubMenu?: (value: boolean, ignoreCollapse?: boolean) => void;
  isCollapsed: boolean;
  setIsCollapsed: (value: boolean) => void;
  fetchedShellData: boolean;
}
